exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#user-reset-password .sign-in-logo{text-align:center;margin:0;padding-bottom:20px}#user-reset-password .sign-in-logo img{filter:invert(100%)}#user-reset-password .login-button{width:100%;text-align:center}", ""]);

// exports
